module.exports = __webpack_public_path__ + "static/media/FullHD_SU22_50th_HeroArt_16x9.d401a4d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/FullHD_SU22_50th_HeroArt_16x9.jpg
// module id = 432
// module chunks = 0